export const baseURL = "/employee-dashboard";
export const adminEmployeeParam = "employee_form_id";
export const adminBaseDashboardURL = `/company-admin/employee-dashboard/:${adminEmployeeParam}`;

const urlHelper = (url: string) => (isAdminMode: boolean | null | undefined, id: string | null | undefined) =>
  isAdminMode ? `/company-admin/employee-dashboard/${id || `:${adminEmployeeParam}`}${url}` : `${baseURL}${url}`;

// Benefits URLs
export const homeURL = urlHelper("/");
export const mobileIdCardsBaseURL = "/mobile-id-cards";
export const mobileIdCardsURL = urlHelper(mobileIdCardsBaseURL);
export const viewCoveragesBaseURL = "/view-coverage";
export const viewCoveragesURL = urlHelper(viewCoveragesBaseURL);
export const beneficiariesViewBaseURL = "/beneficiaries";
export const beneficiariesViewURL = urlHelper(beneficiariesViewBaseURL);
export const beneficiariesEditBaseURL = "/edit-beneficiaries";
export const beneficiariesEditURL = urlHelper(beneficiariesEditBaseURL);

export const viewClaimBaseURL = "/claims";
export const viewClaimURL = urlHelper("/claims");
export const openClaimsBaseURL = "/open-claims";
export const openClaimsURL = urlHelper(openClaimsBaseURL);
export const submitClaimsBaseURL = "/submit-claims";
export const submitClaimsURL = urlHelper(submitClaimsBaseURL);

export const doctorFinderURL = urlHelper("/doctor-finder");

// Change URLs
export const addDependentCoverageBaseURL = "/add-dependent";
export const addDependentCoverageURL = urlHelper(addDependentCoverageBaseURL);

export const editDependentInformationBaseURL = "/edit-dependent-information";
export const editDependentInformationURL = urlHelper(editDependentInformationBaseURL);

export const viewChangeDependentCoverageURL = "/change-dependent-coverage";
export const dependentCoverageURL = urlHelper(viewChangeDependentCoverageURL);

export const viewEmployeeDependentAddedURL = "/added-employee-dependent";
export const employeeDependentAddedURL = urlHelper(viewEmployeeDependentAddedURL);

export const employeeInformationBaseURL = "/employee-information";
export const employeeInformationURL = urlHelper(employeeInformationBaseURL);

export const basicDetailsURL = urlHelper("/employee-information/basic-details");
export const basicDetailsBaseURL = "/basic-details";
export const contactInformationBaseURL = "/contact-information";
export const contactInformationURL = urlHelper("/employee-information/contact-information");

export const payrollInformationURL = urlHelper("/payroll-info");

// Reference URLs
export const formsAndDocumentsURL = urlHelper("/view-forms");
export const faqURL = "/support";
export const costEstimatorURL = "/procedures";

// Utils pages
export const successURL = (formName: string | null | undefined) => `${baseURL}/success${formName ? `?formName=${formName}` : ""}`;
